module.exports = __webpack_public_path__ + "img/feature-4.d1600ceb.png";